// Variant spread toggle: persists the shopper's choice as the showVariants
// cart attribute (survives navigation, readable server-side), then reloads so
// Liquid re-renders the grid. Shared by the collection grid and search results.
//
// The value is always written explicitly as 'true' or 'false'. An empty string
// deletes the attribute, which would be read back as "no choice made" and fall
// through to the theme's default - so it can never stand in for "on".
(function () {
  function bind() {
    document.querySelectorAll('.variant-spread-toggle .toggle-switch__input').forEach(function (toggle) {
      if (toggle.dataset.variantSpreadBound === 'true') return;
      toggle.dataset.variantSpreadBound = 'true';

      toggle.addEventListener('change', function (event) {
        event.stopPropagation();
        toggle.disabled = true;

        // Dim the grid and show a spinner pinned to its top. The toolbar count
        // spinner is wrong here - the product count doesn't change.
        var grid = document.querySelector('#ProductGridContainer .collection');
        if (grid) grid.classList.add('loading');
        document.querySelectorAll('.variant-spread-spinner').forEach(function (spinner) {
          spinner.classList.remove('hidden');
        });

        fetch(window.Shopify.routes.root + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ attributes: { showVariants: toggle.checked ? 'true' : 'false' } }),
        })
          .then(function (response) {
            return response.json();
          })
          .then(function () {
            window.location.reload();
          })
          .catch(function (error) {
            console.error('Variant spread toggle failed:', error);
            // Nothing was saved and we are not reloading, so put the switch
            // back where it was rather than leave it showing a state the
            // server does not have.
            toggle.checked = !toggle.checked;
            toggle.disabled = false;
            if (grid) grid.classList.remove('loading');
            document.querySelectorAll('.variant-spread-spinner').forEach(function (spinner) {
              spinner.classList.add('hidden');
            });
          });
      });

      toggle.addEventListener('input', function (event) {
        event.stopPropagation();
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }
})();
